import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLoginClick = () => {
    const signInUrl = import.meta.env.VITE_WEBPAGE_URL + '/sign-in';
    window.open(signInUrl, '_blank');
    closeMenu();
  };

  const toggleMenu = () => {
    console.log('Toggle menu clicked, current state:', isMenuOpen);
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.navbar')) {
        closeMenu();
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle ${isMenuOpen ? 'active' : 'collapsed'}`}
            onClick={toggleMenu}
            aria-expanded={isMenuOpen}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <Link className="navbar-brand page-scroll" to="/">
            <img 
              src="/img/logo.png" 
              alt="Peak Risk Management" 
              className="navbar-logo"
            />
          </Link>{" "}
        </div>

        <div
          className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll" onClick={closeMenu}>
                Features
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll" onClick={closeMenu}>
                About
              </a>
            </li>
            <li>
              <a href="#solutions" className="page-scroll" onClick={closeMenu}>
                Solutions
              </a>
            </li>
            <li>
              <a href="#pricing" className="page-scroll" onClick={closeMenu}>
                Pricing
              </a>
            </li>
            <li>
              <a href="#demo" className="page-scroll" onClick={closeMenu}>
                Demo
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" onClick={closeMenu}>
                Contact
              </a>
            </li>
            <li className="login-btn-wrapper">
              <a href="#" className="login-btn" onClick={handleLoginClick}>
                Login
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
